



<template>
  <div>
    <div class="smart-main-search-container flex flex-wrap">

      <div class="flex-1"></div>
      <div class="flex">
        <el-button type="primary" @click="add" plain  >新增电价</el-button>
      </div>
    </div>

    <div class="content mt-20">
      <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
    </div>

    <div class="flex flex-right mt-20">
      <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
    </div>
    <form-dialog ref="model" title="电价信息" @on-confirm="save">
      <div slot="dialog-main">
        <el-form>
          <div class="flex flex-mid">
            <div class="flex-1">
              <el-form-item  label="电价名称" label-width="160px">
                <el-input v-model="temp.name"></el-input>
              </el-form-item>
            </div>

            <div  class="flex-1">
              <el-form-item  label="基础电价" label-width="160px">
                <el-input v-model="temp.money"></el-input>
              </el-form-item>
            </div>
            <div  class="flex-1">
              <el-form-item  label="服务附加费" label-width="160px">
                <el-input v-model="temp.additionalCharge"></el-input>
              </el-form-item>
            </div>

          </div>

          <div class="flex flex-mid">
            <div class="flex-1">
              <el-form-item  label="电价类型" label-width="160px">
                <dropdown placeholder="请选择电价类型" v-model="temp.type"  :data-list="globalData.priceType" ></dropdown>
              </el-form-item>
            </div>
            <div class="flex-1">
              <el-form-item  label="阶梯类型" label-width="160px">
                <dropdown placeholder="请选择阶梯类型" v-model="temp.ladderType"  :data-list="globalData.ladderTypeList" ></dropdown>
              </el-form-item>
            </div>
          </div>

          <div class="flex flex-mid">
            <div v-show="temp.type == '2'" class="flex-1">
              <el-form-item  label="电价-尖（元）" label-width="160px">
                <el-input v-model="temp.sharpMoney"></el-input>
              </el-form-item>
            </div>
            <div v-show="temp.type == '2'" class="flex-1">
              <el-form-item  label="电价-峰（元）" label-width="160px">
                <el-input v-model="temp.peakMoney"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="flex flex-mid">
            <div v-show="temp.type == '2'" class="flex-1">
              <el-form-item  label="电价-平（元）" label-width="160px">
                <el-input v-model="temp.flatMoney"></el-input>
              </el-form-item>
            </div>
            <div v-show="temp.type == '2'" class="flex-1">
              <el-form-item  label="电价-谷（元）" label-width="160px">
                <el-input v-model="temp.valleyMoney"></el-input>
              </el-form-item>
            </div>
          </div>



          <div class="flex flex-mid">
            <div class="flex-1">
              <el-form-item  label="阶梯1电量（kwh)" label-width="160px">
                <el-input v-model="temp.quantity1"></el-input>
              </el-form-item>
            </div>
            <div class="flex-1">
              <el-form-item  label="阶梯1提高价格（元）" label-width="160px">
                <el-input v-model="temp.extraCharges1"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="flex flex-mid">
            <div class="flex-1">
              <el-form-item  label="阶梯2电量（kwh）" label-width="160px">
                <el-input v-model="temp.quantity2"></el-input>
              </el-form-item>
            </div>
            <div class="flex-1">
              <el-form-item  label="阶梯2提高价格（元）" label-width="160px">
                <el-input v-model="temp.extraCharges2"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="flex flex-mid">
            <div class="flex-1">
              <el-form-item  label="阶梯3电量（kwh）" label-width="160px">
                <el-input v-model="temp.quantity3"></el-input>
              </el-form-item>
            </div>
            <div class="flex-1">
              <el-form-item  label="阶梯3提高价格（元）" label-width="160px">
                <el-input v-model="temp.extraCharges3"></el-input>
              </el-form-item>
            </div>
          </div>


        </el-form>
      </div>
    </form-dialog>
  </div>
</template>
<script>
  import LoadButton from "../../components/LoadButton";
  import Pagination from "../../components/Pagination";
  import SmartTable from "../../components/SmartTable";
  import FormDialog from "../../components/FormDialog";
  import UploadImg from "../../components/UploadImg";
  import Dropdown from "../../components/Dropdown";
  export default{
    components: {
      Dropdown,
      UploadImg,
      FormDialog,
      SmartTable,
      Pagination,
      LoadButton
    },
    data(){
      return {
        searchParams: {
          page: 1
        },
        searchData: {},
        opt: [
          {label:'编辑',fn:this.getDetail}
        ],
        labels: [
          {prop: 'name', label: '电价名'},
        ],
        temp:{}
      }
    },
    computed:{
      list(){
        let  arr = []
        for(var i in this.$store.state.tasKeyMap){
          arr.push({id:i,name:this.$store.state.tasKeyMap[i]})
        }
        return arr
      },
    },
    mounted(){
      this.getList()
    },
    methods: {
      search(stop){
        this.searchParams.page = 1
        this.getList(stop)
      },
      toPage(page){
        this.searchParams.page = page
        this.getList()
      },
      getList(callback){
        this.$http$({method: 'get', url: "/smartMeter/price",data:this.searchParams,  load: 1}, (data) => {
          callback ? callback() : ''
          this.searchData = data
        })
      },
      getDetail(obj){
        this.temp = JSON.parse(JSON.stringify(obj))
        this.$refs.model.show()
      },
      add(){
        this.temp = {}
        this.$refs.model.show()
      },
      save(){
        this.temp.rate1 = this.temp.step1
        let method = 'post',url='/smartMeter/price',msg = '新增电价成功！'
        if(this.temp.id){
            method = "put"
          // url = '/smartMeterServer/price/update'
          msg = '修改电价信息成功！'
        }
        this.$http$({method:method,url:url,data:this.temp},(data) => {
          this.getList()
          this.$success(msg)
        })

      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/admin/Price.vue